import { render, staticRenderFns } from "./PopMessage.vue?vue&type=template&id=21b44451&scoped=true"
import script from "./PopMessage.vue?vue&type=script&lang=js"
export * from "./PopMessage.vue?vue&type=script&lang=js"
import style0 from "./PopMessage.vue?vue&type=style&index=0&id=21b44451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b44451",
  null
  
)

export default component.exports